export default class extends Controller {
  static targets = ['bindTo'];

  connect() {
    google.charts.load('45', { 'packages': ['corechart'] });
    google.charts.setOnLoadCallback(this.drawChart.bind(this));
  }

  drawChart() {
    var data = new google.visualization.DataTable();
    data.addColumn(this.xType, this.xLabel);
    data.addColumn(this.yType, this.yLabel);
    const dataArray = this.dataArray;
    data.addRows(dataArray);
    var dataView = new google.visualization.DataView(data);
    dataView.setColumns([0, 1, { calc: this.calculateColor.bind(this), type: 'string', role: 'style' }]);
    var chart = new google.visualization.LineChart(document.querySelector(this.selector));
    chart.draw(dataView, {
      chartArea:        { width: this.chartWidth, height: this.chartHeight },
      hAxis:            {
        textPosition: this.xTextPosition,
        format:       this.xType == 'date' ? "MMM d, yyyy" : null,
        ticks:        dataArray.map(d => d[0])
      },
      interpolateNulls: true,
      legend:           { position: this.showLegend ? '' : 'none' },
      lineWidth:        3,
      pointSize:        5,
      vAxis:            {
        textPosition: this.yTextPosition,
        ticks:        this.yTicks
      }
    });
  }

  calculateColor(data, row) {
    const prevVal = Array.from({ length: row })
                      .reduce(
                        (val, _, i) => {
                          // Each row represents an x, y pair, so we'll start from the most recent, previous row and look for its value.
                          // Since values can be null, we need to keep looking if the value is null, so we cycle through them all in
                          // reverse order until we find the first one with a y value.
                          if (val || val ===0) return val;
                          const prev = data.getValue(row - (i + 1), 1);
                          return prev === data.getValue(row, 1) ? null : prev;
                        },
                        null
                      );
    return (prevVal || 0) <= data.getValue(row, 1) ? this.upColor : this.downColor;
  }

  //
  // GETTERS AND SETTERS
  //

  get yLabel() {
    return this.data.get('y-label') || '';
  }

  get xLabel() {
    return this.data.get('x-label') || '';
  }

  get yType() {
    return this.data.get('y-type');
  }

  get xType() {
    return this.data.get('x-type');
  }

  get dataArray() {
    return JSON.parse(this.data.get('data')).map(p => [this.xType == 'date' ? new Date(p[0]) : p[0], p[1]]);
  }

  get upColor() {
    return this.data.get('up-color') || '#00ff00';
  }

  get downColor() {
    return this.data.get('down-color') || '#ff0000';
  }

  get selector() {
    return this.data.get('selector');
  }

  get showLegend() {
    return !!this.yLabel;
  }

  get chartWidth() {
    return this.data.get('chart-width') || this.element.offsetWidth - 8;
  }

  get chartHeight() {
    return this.data.get('chart-height');
  }

  get xTextPosition() {
    return this.data.get('x-text-position') || 'none';
  }

  get yTextPosition() {
    return this.data.get('y-text-position') || 'in';
  }

  get yTicks() {
    return JSON.parse(this.data.get('y-ticks'));
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/ticker-chart-controller.js